<!--选择平台内容弹框-->
<template lang="pug">
  modal-dialog(modal-scale="large")
    .modal-card(slot="card")
      .modal-header
        .modal-card-title 
          a.shop 选择优惠券
        .close-button(@click="modalClose")
      .modal-body
        .section-filter.is-horizontal
          .field-group.is-horizontal
            .field.is-keyword
              label.label 关键字搜索
              custom-input(v-model="filter_data.keywords", placeholder="优惠券名称", @keyupEnter="searchFilter(1)")
            .field.staff-wrapper
              label.label 优惠券类型
              custom-select(v-model="filter_data.coupon_type", :list="coupon_type_list", nameField="name")
            .field
              a.button.primary(@click="searchFilter(1)") 搜索
            .field
              a.button(@click="resetFilter") 重置
        empty-page(v-if="!data_list.length && is_initiated", :tip="'暂无内容'")
        .table-wrapper(v-if="data_list && data_list.length !== 0")
          table.table
            thead
              tr
                td(width="80")
                td(width="120") 优惠券名称
                td(width="60") 优惠券类型
                td(width="80") 优惠券金额（折扣）
                td(width="100") 库存数量
                td(width="100") 剩余库存
                td(width="100") 使用范围
            tbody
              tr(v-for="item in data_list")
                td
                  .simple-td
                    .radio(:class="{disabled: item.totals>0 && item.available_stock<=0}" v-if="typeof editIndex == 'number'")
                      input(type="radio", :id="item.coupon_id", :value="item", v-model="selected_item", :checked='item.selected', :disabled='item.totals>0 && item.available_stock<=0')
                      label.sepcific-setting(:for="item.coupon_id" :class="{disabled: item.totals>0 && item.available_stock<=0}")
                    .checkbox(v-if="typeof editIndex != 'number'")
                      input(type="checkbox", :id="item.coupon_id", :value="item", name="modal", v-model="selected_item", :checked='item.selected' :disabled='item.totals>0 && item.available_stock<=0')
                      label.sepcific-setting(:for="item.coupon_id" :class="{disabled: item.totals>0 && item.available_stock<=0}")
                td
                  .simple-td(v-text="item.coupon_name")
                td
                  .simple-td {{item.coupon_type_name}}
                td {{item.coupon_type === 4 ? (item.discount_amount / 100) + ' 折' : '¥ ' + (item.discount_amount / 100)}}
                td
                  .simple-td {{item.totals <=0 ? '无限制': item.totals}}
                td
                  .simple-td {{item.totals <=0 ? '无限制': item.available_stock}}
                td
                  .simple-td {{item.coupon_use_type_name}}
        .tfoot
          pagination(:pagination-data="pagination_data", @input="paging")
      .modal-footer.level
        .level-left
          div 注：优惠券最多添加六张
        .level-right
          a.button.large(@click="modalClose") 取消
          a.button.large.primary(v-if="selected_item", @click="complete") 确定
</template>

<script>
  import ModalDialog from '@/components/generics/ModalDialog'
  import CustomSelect from '@/components/generics/form/CustomSelect'
  import CustomInput from '@/components/generics/form/CustomInput'
  import EmptyPage from '@/components/generics/EmptyPage'
  import ModalInteractions from '@/mixins/utilities/modalInteractions'
  import marketingMixin from '@/mixins/modules/marketing'
  import Pagination from '@/components/generics/Pagination'

  export default {
    name: 'ChooseCoupon',
    components: {
      ModalDialog,
      CustomSelect,
      CustomInput,
      EmptyPage,
      Pagination,
    },
    mixins: [ModalInteractions, marketingMixin],
    props: {
      array: {
        type: Array,
        default: () => [],
      },
      editIndex: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        is_initiated: false,
        filter_data: { // 搜索条件
          keywords: '',
          coupon_type: {},  // 优惠券类型
        },
        coupon_type_list: [ // 下拉选项 - 优惠券类型
          { id: 1, name: '代金券' },
          { id: 2, name: '兑换券' },
          { id: 3, name: '满减券' },
          { id: 4, name: '折扣券' },
        ],
        data_list: [],
        pagination_data: { // 分页
          current_page: 1,
          per_page: 20,
          last_page: 1,
          total: 0,
        },
        selected_item: [], // 选中的
      }
    },
    methods: {
      // 搜索按钮
      searchFilter (tag) {
        if (tag) {
          this.pagination_data.current_page = 1
        }
        this.fetchData()
      },
      // 重置
      resetFilter () {
        this.pagination_data.current_page = 1
        this.filter_data.keywords = ''
        this.filter_data.coupon_type = {}
        this.fetchData()
      },
      // 获取优惠券列表
      async fetchData () {
        let params = {
          keyword: this.filter_data.keywords.trim(),
          coupon_type: this.filter_data.coupon_type.id || null,
          page: this.pagination_data.current_page,
          per_page: this.pagination_data.per_page,
          is_effective: 1, // 未过期优惠券
        }
        try {
          const {response, result} = await this.fetchCoupons(params)
          if (response.status === 200 && result.code === 0) {
            this.data_list = result.data
            this.data_list.forEach(x => {
              x.type = 8
              this.selected_item.forEach(y => {
                if (x.coupon_id === y.coupon_id) {
                  x.selected = true
                }
              })
              console.log('1111', x.totals > 0 && x.available_stock < 0)
            })
            this.pagination_data = result.meta
          } else {
            this.$store.dispatch('showMessage', {
              type: 'failure',
              title: '获取优惠券列表失败',
              content: `服务异常，请稍后再试（${response.status}${result && result.code ? ' ' + result.code : ''}）`,
            })
          }
        } catch (err) {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取优惠券列表失败',
            content: `服务异常，请稍后再试（${err.response ? err.response.status : err}${err.result && err.result.code ? ' ' + err.result.code : ''}）`,
          })
        }
        this.is_initiated = true
      },
      // 分页
      paging (state, evt) {
        this.pagination_data = state
        this.searchFilter(0)
      },
      // 完成
      complete () {
        // 如果已选择的优惠券数量 >= 6 && 有选择单选框 && 是添加
        if (this.selected_item.length > 6 && typeof this.editIndex !== 'number') {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '提示',
            content: '注：优惠券最多添加六张',
          })
          return
        }
        this.modalResolve({
          type: 8,
          data: this.selected_item,
        })
      },
    },
    mounted () {
      this.fetchData() // 获取优惠券列表
      this.selected_item = [...this.array]
      if (this.selected_item.length) {
        this.selected_item.map(item => {
          item.selected = true
        })
      }
    },
  }
</script>

<style lang="stylus" scoped>
  @import '~@/stylus/mixins'
  .modal-header
    padding 20px 24px
  .modal-card
    width 950px !important
  .modal-card-title
    overflow hidden
    .shop
      float left
      margin-right 20px
      color #353535
    .active
      border-bottom 2px solid #ffbb29
  .modal-footer
    padding 12px 16px
  .modal-body
    position relative
    height 420px
    display flex
    flex-direction column
    padding-bottom 36px
  .table-wrapper
    padding 8px 16px
    flex-grow 1
    background standBackground
    .items
      + .items
        margin-top 8px
      display flex
      height 48px
      align-items center
      background #ffffff
      padding 0 16px
    .checkbox
      flex-shrink 0
      margin-right 16px
      .disabled
        &:before
          content: '';
          display: block;
          background: #ccc;
          width: 16px;
          height: 16px;
          border: 1px solid #ccc;
          border-radius: 1px;
          position: absolute;
          z-index: 1;
          left: 0;
          top: 0;
          box-sizing: border-box;
    .radio
      .disabled
        &:before
          content: '';
          display: block;
          background: #ccc;
          width: 16px;
          height: 16px;
          border: 1px solid #ccc;
          border-radius: 100%;
          position: absolute;
          z-index: 1;
          left: 0;
          top: 0;
          box-sizing: border-box;
    .image
      width 32px
      height 32px
      flex-shrink 0
      margin-right 16px
    .item-content
      max-width 343px
      margin-right 16px
      font-size 13px
      line-height 16px
      flex-grow 1
      text-overflow ellipsis
      white-space nowrap
      overflow hidden
    .price-content
      font-weight bold
      width 100px
      flex-shrink 0
      font-size 13px
      line-height 16px
      text-overflow ellipsis
      white-space nowrap
      overflow hidden
  .simple-td
    height 32px
    line-height 32px
    display flex
    align-items center
  .limit-info
    font-size 13px
    color darker
    align-items center
    .count
      color mediumYellow
      margin-left 10px
  .filter-wrapper
    flex-shrink 0
    box-sizing border-box
    background #e8e9eb
    padding 12px 16px
    display flex
    flex-direction row
  .custom-select
    width 128px
    margin-right 8px
    flex-shrink 0
  .custom-input
    flex-grow 1
    margin-right 8px
  .filter-wrapper
    .button + .button
      margin-left 8px
  .pagination
    flex-shrink 0
    height 36px
    display flex
    justify-content space-between
    align-items center
    padding 0 16px
    background #ffffff
    box-shadow 0 -1px 12px 0 rgba(0, 0, 0, 0.08)
  .pagination-info
    font-size 13px
    line-height 16px
    color lightGrey
  .page-turning
    font-size 13px
    line-height 16px
    color lightGrey
    height 100%
    display flex
    align-items center
    cursor pointer
    &.is-disabled
      opacity .2
      pointer-events none
    &:hover
      color mediumYellow
      .pre-icon
        background-image url('~@/assets/prev-hover.svg')
      .next-icon
        background-image url('~@/assets/next-hover.svg')
  .pre-icon
  .next-icon
    display inline-block
    width 16px
    height 16px
    background url('~@/assets/prev.svg') no-repeat center center
    background-size 14px
  .next-icon
    background-image url('~@/assets/next.svg')
  .img
    width 32px
    height 32px
  .tfoot
    z-index 3
  .radio
    width 16px
    height 16px
    label
      width 16px
      height 16px
      padding-left 14px
    input[type="radio"]
      width 16px
      height 16px
.level-left
  margin 12px 0
  font-size 13px
  color red 
</style>



// WEBPACK FOOTER //
// src/components/content/modal/ChooseCoupon.vue